webpackJsonp([68800189925204],{

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	__webpack_require__(55);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactCookieBanner = __webpack_require__(61);
	
	var _reactCookieBanner2 = _interopRequireDefault(_reactCookieBanner);
	
	var _cookieconsent = __webpack_require__(32);
	
	var actions_cookies = _interopRequireWildcard(_cookieconsent);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by vaibhav on 31/3/18
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var cookies = new _reactCookieBanner.Cookies();
	
	var d = new Date();
	var year = d.getFullYear();
	var month = d.getMonth();
	var day = d.getDate();
	var expiry = new Date(year + 1, month, day);
	
	var AlertLink = function (_Component) {
	  _inherits(AlertLink, _Component);
	
	  function AlertLink(props) {
	    _classCallCheck(this, AlertLink);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      cookies_all: _this.props.cookies_all
	    };
	    _this._enable_all_cookies = _this._enable_all_cookies.bind(_this);
	
	    return _this;
	  }
	
	  AlertLink.prototype._enable_all_cookies = function _enable_all_cookies() {
	    this.props.enable_all_cookies();
	
	    cookies.set('ub_cc', true, {
	      expires: expiry
	    });
	
	    this.setState({ cookies_all: true });
	
	    (0, _gatsbyLink.navigateTo)('/');
	  };
	
	  AlertLink.prototype.render = function render(props) {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.cookies_all === false ? _react2.default.createElement(
	        'button',
	        { className: 'button-close', onClick: function onClick() {
	            return _this2._enable_all_cookies();
	          } },
	        'EINVERSTANDEN'
	      ) : ''
	    );
	  };
	
	  return AlertLink;
	}(_react.Component);
	
	AlertLink.propTypes = {};
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var cookies_all = _ref.cookies_all,
	      enable_all_cookies = _ref.enable_all_cookies;
	
	  return { cookies_all: cookies_all, enable_all_cookies: enable_all_cookies };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    enable_all_cookies: function enable_all_cookies() {
	      return dispatch(actions_cookies.enable_all_cookies());
	    }
	  };
	};
	
	var ConnectedAlertLink = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlertLink);
	
	exports.default = ConnectedAlertLink;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = {"lang":"de","home_1":"Digital  & Creative","home_2":"Having spent the better part of his career helping companies apply a positive focus to their branding, print and online identities package design and marketing messages, Rémi has given a unique voice to numerous corporate identities through his sought-after design services.<br>Responsible for all design and technological decisions from the briefing to completion.<br><br/>Specialty:<br>Branding, Web development for clients in Europe and in the USA, especially in the sport of Dressage, Luxury brands, interior design, architects and Law firms.","home_4":"N","home_5":"M","home_6":"P ","titles":[{"t":"FEATURED WORK"},{"t":""},{"t":"SERVICES"},{"t":"ARCHITECTURE"},{"t":"A"},{"t":"B"}],"siteTitle":"i18n with Gatsby","hi":"Hi!","welcome":"Welcome to our site.","about":"About us","aboutCopy":"This page is about us.","backToHomepage":"Back to the homepage","closedToday":"Closed today","legal":"Imprint","legal_link":"/en/imprint","cookie_link":"/en/cookie-policy","label_cookie_link":"Cookie Policy","agree":"I agree","deny":"I desagree","close":"Close","more":" + More info","view":" + Visit","more_":"More","cookies_n":"Functional cookies","cookies_a":"Third party cookies","options":"Cookies options","p_1":"We set those cookies per default, without them the website can not work properly.","p_2":"Do you allow third party services to create cookies? We offer the use of Google Maps. If you agree, Google will create some cookies.","p_3":"By navigating through the website you accept our cookies policy.","map_deny":"You must authorize the use of tracking cookies to see the map.","map_title":"location map","links":[{"l":"Services","u":"#"},{"l":"Contact","u":"contact"},{"l":"Z","u":"z-z"}]}

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports = {"lang":"en","home_1":"Creating beautiful work by Design & Code.","home_2":"Rémi Blot is a boutique studio founded in 2006, specialising in web development and branding for premium and luxury brands. We love digital creations and enjoy crafting them to both look and work great.","home_4":"N","home_5":"M","home_6":"P ","titles":[{"t":"FEATURED WORK"},{"t":""},{"t":"SERVICES"},{"t":"ARCHITECTURE"},{"t":"A"},{"t":"B"}],"siteTitle":"i18n with Gatsby","hi":"Hi!","welcome":"Welcome to our site.","about":"About us","aboutCopy":"This page is about us.","backToHomepage":"Back to the homepage","closedToday":"Closed today","legal":"Imprint","legal_link":"/en/imprint","cookie_link":"/en/cookie-policy","label_cookie_link":"Cookie Policy","agree":"I agree","deny":"I desagree","close":"Close","more":" + More info","view":" + Launch","more_":"More","cookies_n":"Functional cookies","cookies_a":"Third party cookies","options":"Cookies options","p_1":"We set those cookies per default, without them the website can not work properly.","p_2":"Do you allow third party services to create cookies? We offer the use of Google Maps. If you agree, Google will create some cookies.","p_3":"By navigating through the website you accept our cookies policy.","map_deny":"You must authorize the use of tracking cookies to see the map.","map_title":"location map","links":[{"l":"Services","u":"services"},{"l":"About","u":"about"},{"l":"Contact","u":"contact"},{"l":"Branding","u":"branding"}]}

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = {"lang":"ru","home_1":"Digital  & Creative","home_2":"Having spent the better part of his career helping companies apply a positive focus to their branding, print and online identities package design and marketing messages, Rémi has given a unique voice to numerous corporate identities through his sought-after design services.<br>Responsible for all design and technological decisions from the briefing to completion.<br><br/>Specialty:<br>Branding, Web development for clients in Europe and in the USA, especially in the sport of Dressage, Luxury brands, interior design, architects and Law firms.","home_4":"N","home_5":"M","home_6":"P ","titles":[{"t":"FEATURED WORK"},{"t":""},{"t":"SERVICES"},{"t":"ARCHITECTURE"},{"t":"A"},{"t":"B"}],"siteTitle":"i18n with Gatsby","hi":"Hi!","welcome":"Welcome to our site.","about":"About us","aboutCopy":"This page is about us.","backToHomepage":"Back to the homepage","closedToday":"Closed today","legal":"Imprint","legal_link":"/en/imprint","cookie_link":"/en/cookie-policy","label_cookie_link":"Cookie Policy","agree":"I agree","deny":"I desagree","close":"Close","more":" + More info","view":" + Visit","more_":"More","cookies_n":"Functional cookies","cookies_a":"Third party cookies","options":"Cookies options","p_1":"We set those cookies per default, without them the website can not work properly.","p_2":"Do you allow third party services to create cookies? We offer the use of Google Maps. If you agree, Google will create some cookies.","p_3":"By navigating through the website you accept our cookies policy.","map_deny":"You must authorize the use of tracking cookies to see the map.","map_title":"location map","links":[{"l":"Services","u":"#"},{"l":"Contact","u":"contact"},{"l":"Z","u":"z-z"}]}

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.PageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(35);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Testimonials = __webpack_require__(120);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _OpenTime = __webpack_require__(119);
	
	var _OpenTime2 = _interopRequireDefault(_OpenTime);
	
	var _ConnectedAlertLink = __webpack_require__(81);
	
	var _ConnectedAlertLink2 = _interopRequireDefault(_ConnectedAlertLink);
	
	var _Fade = __webpack_require__(30);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ImagesCarousel = __webpack_require__(82);
	
	var _ImagesCarousel2 = _interopRequireDefault(_ImagesCarousel);
	
	var _reactFlexboxGrid = __webpack_require__(41);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _UbHome = __webpack_require__(122);
	
	var _UbHome2 = _interopRequireDefault(_UbHome);
	
	var _Ub = __webpack_require__(121);
	
	var _Ub2 = _interopRequireDefault(_Ub);
	
	var _SvgEl = __webpack_require__(44);
	
	var _SvgEl2 = _interopRequireDefault(_SvgEl);
	
	var _remark = __webpack_require__(26);
	
	var _remark2 = _interopRequireDefault(_remark);
	
	var _remarkPresetLintRecommended = __webpack_require__(25);
	
	var _remarkPresetLintRecommended2 = _interopRequireDefault(_remarkPresetLintRecommended);
	
	var _remarkHtml = __webpack_require__(24);
	
	var _remarkHtml2 = _interopRequireDefault(_remarkHtml);
	
	var _de = __webpack_require__(57);
	
	var _de2 = _interopRequireDefault(_de);
	
	var _en = __webpack_require__(58);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _ru = __webpack_require__(59);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by vaibhav on 31/3/18
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var bowser = __webpack_require__(47);
	
	// Messages
	
	
	var messages = { de: _de2.default, en: _en2.default, ru: _ru2.default };
	
	var PageTemplate = exports.PageTemplate = function PageTemplate(_ref) {
	  var title = _ref.title,
	      templateKey = _ref.templateKey,
	      heading = _ref.heading,
	      description = _ref.description,
	      meta_title = _ref.meta_title,
	      meta_description = _ref.meta_description,
	      language = _ref.language,
	      closingDay = _ref.closingDay,
	      dayOn = _ref.dayOn,
	      dayOff = _ref.dayOff,
	      grid = _ref.grid,
	      page_heading = _ref.page_heading,
	      text = _ref.text,
	      text1 = _ref.text1,
	      browserDataName = _ref.browserDataName,
	      browserSafari = _ref.browserSafari,
	      osDataName = _ref.osDataName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        bodyAttributes: {
	          class: templateKey + ' dct-' + browserDataName + ' dct-' + osDataName + browserSafari
	        }
	      },
	      _react2.default.createElement('html', { lang: language }),
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description })
	    ),
	    _react2.default.createElement(
	      _Fade2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1 has-margin-top-2' },
	            _react2.default.createElement('h1', { className: 'title title-section is-size-1 has-text-centered sand-dark', dangerouslySetInnerHTML: { __html: page_heading } }),
	            _react2.default.createElement('h2', { className: 'title-sub is-size-3 has-text-centered', dangerouslySetInnerHTML: { __html: heading } })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section section--gradient bg-sand' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1 has-text-centered' },
	            _react2.default.createElement('img', { className: 'portrait-circle', src: '/static/remi-blot-1.jpg', alt: 'R\xE9mi Blot Digital agency' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'has-text-centered' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'R\xE9mi Blot'
	              ),
	              _react2.default.createElement('br', null),
	              'Founder'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement('div', { className: 'eu-dsgvo', dangerouslySetInnerHTML: { __html: (0, _remark2.default)().use(_remarkPresetLintRecommended2.default).use(_remarkHtml2.default).processSync(text).toString() } })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  closingDay: _propTypes2.default.number,
	  dayOn: _propTypes2.default.string,
	  dayOff: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  heading: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  text1: _propTypes2.default.string,
	  grid: _propTypes2.default.object,
	  page_heading: _propTypes2.default.string
	
	};
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      browserData: '',
	      osData: ''
	    };
	    return _this;
	  }
	
	  Page.prototype.componentDidMount = function componentDidMount() {
	    var browser = bowser.getParser(window.navigator.userAgent);
	    var browserData = browser.parsedResult.browser;
	    var osData = browser.parsedResult.os;
	    this.setState({
	      browserData: browserData,
	      osData: osData
	    });
	  };
	
	  Page.prototype.render = function render() {
	    var frontmatter = this.props.data.markdownRemark.frontmatter;
	    var siteMetadata = this.props.data.site.siteMetadata;
	
	
	    return _react2.default.createElement(PageTemplate, {
	      title: frontmatter.title,
	      meta_title: frontmatter.meta_title,
	      templateKey: frontmatter.templateKey,
	      browserDataName: this.state.browserData.name,
	      osDataName: this.state.osData.name,
	      browserSafari: this.state.browserData.name !== 'Safari' ? ' dct-not-Safari' : '',
	      meta_description: frontmatter.meta_description,
	      heading: frontmatter.heading,
	      description: frontmatter.description,
	      language: frontmatter.language,
	      closingDay: siteMetadata.closingDay,
	      dayOn: siteMetadata.dayOn,
	      dayOff: siteMetadata.dayOff,
	      text: frontmatter.text,
	      text1: frontmatter.text1,
	      grid: this.props.data,
	      page_heading: frontmatter.page_heading
	    });
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	Page.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object,
	      siteMetadata: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = Page;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-about-js-b2e56b17f4501e5b35a5.js